import { useEffect } from 'react'

import { navigate } from '@redwoodjs/router'

import { InsightsPageType } from 'src/components/InsightsCommon/types'
import { useHomePage } from 'src/hooks/use-home-page'
import {
  useMyRecordTypes,
  useIsGovWellStaff,
  useIsUnrestrictedGov,
} from 'src/layouts/AppStateContextLayout/utils'
import { FeatureGate, useFeatureFlagging } from 'src/utils/featureFlagging/featureFlagging'

type Props = {
  insightsPageType: InsightsPageType
  shouldHandleRedirect?: boolean
}

export const useCanViewInsightsPage = ({ insightsPageType, shouldHandleRedirect }: Props) => {
  const isUnrestrictedGov = useIsUnrestrictedGov()
  const recordTypes = useMyRecordTypes()
  const homePage = useHomePage()
  const isGovWellStaff = useIsGovWellStaff()

  const featureFlagging = useFeatureFlagging()

  // Enable explicitly for GovWell staff to allow for testing
  const isInsightsInspectionsPageEnabled =
    featureFlagging.checkFeatureFlag(FeatureGate.InsightsInspectionsPage) || isGovWellStaff
  const isInsightsCommunityPageEnabled =
    featureFlagging.checkFeatureFlag(FeatureGate.InsightsCommunityPage) || isGovWellStaff

  const canViewInspectionsPage =
    isInsightsInspectionsPageEnabled && recordTypes?.some((rt) => rt.allowInspections)
  const canViewCommunityPage = isInsightsCommunityPageEnabled

  const canViewInsights =
    isUnrestrictedGov &&
    (insightsPageType !== InsightsPageType.Inspections || canViewInspectionsPage) &&
    (insightsPageType !== InsightsPageType.Community || canViewCommunityPage)

  useEffect(() => {
    if (shouldHandleRedirect && !canViewInsights) {
      navigate(homePage)
    }
  }, [canViewInsights, homePage, shouldHandleRedirect])

  return canViewInsights
}
